import { createAggrApiInstance } from '@/utils/api/axiosInstance'
import { handleApiStatus } from '@/utils/api/handleAPI'

import * as aggr from '@/api-generator/aggr/index'

const feUrlStatisticsApi = createAggrApiInstance(aggr.FrontendUrlStatisticsApi)

export const getFeUrlClicks = async (reqData: aggr.UrlStatsClicksRq) => {
  const res = await handleApiStatus(() => feUrlStatisticsApi.urlstatisticsClicks(reqData))
  return res
}

export const getFeUrlAgeDistribution = async (reqData: aggr.UrlStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlStatisticsApi.urlstatisticsAgedist(reqData))
  return res
}

export const getFeUrlGenderDistribution = async (reqData: aggr.UrlStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlStatisticsApi.urlstatisticsGenderdist(reqData))
  return res
}

export const getFeUrlDeviceDistribution = async (reqData: aggr.UrlStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlStatisticsApi.urlstatisticsDevicedist(reqData))
  return res
}

export const getFeUrlRegionDistribution = async (reqData: aggr.UrlStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlStatisticsApi.urlstatisticsRegiondist(reqData))
  return res
}

export const getFeUrlSourceDistribution = async (reqData: aggr.UrlStatsQueryRq) => {
  const res = await handleApiStatus(() => feUrlStatisticsApi.urlstatisticsSourcedist(reqData))
  return res
}

export const getFeUrlInfo = async (reqData: aggr.UrlStatsUrlInfoRq) => {
  const res = await handleApiStatus(() => feUrlStatisticsApi.urlstatisticsUrlinfo(reqData))
  return res
}

export const getFeUrlStatsClicksSummary = async (reqData: aggr.UrlStatsClicksRq) => {
  const res = await handleApiStatus(() => feUrlStatisticsApi.urlstatisticsClicksummary(reqData))
  return res
}
